import { Card, CardContent, CardHeader } from "@/components/atoms/Card";
import { Paragraph } from "@/components/atoms/Paragraph";
import type { IRequiredPermissionsListProps } from "@/components/molecules/RequiredPermissionsList/types";
import { useTranslations } from "@/hooks/common/useTranslations";

const RequiredPermissionsList = ({ items }: IRequiredPermissionsListProps) => {
  const { t } = useTranslations("installAppDrawer");

  if (!items.length) {
    return null;
  }

  return (
    <Card className="w-full p-6 pt-0 mt-6 max-sm:px-0">
      <CardHeader>
        <Paragraph size="large" fontWeight="bold">
          {t("requiredPermissions")}
        </Paragraph>
      </CardHeader>
      <CardContent>
        <div className="flex flex-row flex-wrap items-center justify-between">
          {items.map((group, index) => {
            return (
              <ul key={index} className="ml-6 list-disc [&>li]:mt-2">
                {group.map((label) => (
                  <li key={label}>
                    <Paragraph>{label}</Paragraph>
                  </li>
                ))}
              </ul>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};

export default RequiredPermissionsList;
